import { useEffect, useState } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { ActivationComponentAssets } from "../../helpers/ActivationAssets";

export const useCountryUpdate = (isShared: boolean) => {
    const {
        params: { country },
    } = useCurrentStateAndParams();

    const [isOpen, setIsOpen] = useState(false);

    const availableCountries = ActivationComponentAssets.availableCountries;

    useEffect(() => {
        if (isShared) {
            return;
        }

        const isCountryAllowed = !!availableCountries.find(({ id }) => id === Number(country));

        if (!isCountryAllowed) {
            setIsOpen(true);
        }
    }, []);

    return { isOpen, setIsOpen, availableCountries };
};
